/* eslint-disable max-len */
import { SvgProps } from './types'

export const PinHouseIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg 
      width="64" 
      height="63" 
      viewBox="0 0 64 63" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      <g clipPath="url(#clip0_333_11699)">
        <path d="M31.9976 55.7343C36.3535 48.5468 40.4244 41.1176 43.9872 33.5026C47.2278 26.5815 51.0012 19.0717 47.835 11.4195C45.2636 5.20477 39.1046 0.979 32.3756 0.824097C32.2331 0.824097 32.0968 0.824097 31.9543 0.824097H31.8737C31.7312 0.824097 31.5949 0.824097 31.4524 0.824097C24.7296 0.991393 18.5768 5.22336 16.0116 11.4443C12.8578 19.1027 16.6374 26.6063 19.8904 33.5212C23.4656 41.13 27.5488 48.5468 31.9171 55.7343" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M42.673 47.1093H53.5906L63.176 61.8065H42.673H21.1228H0.824219L10.4097 47.1093H21.1228" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M25.0879 56.0565H38.7504" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M43.8245 17.3058L31.9279 7.68323L20.0312 17.3058" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M29.1152 28.7501V21.8724H34.7413V28.7501" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23.9102 17.5165V28.7501H39.9458V17.5165" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    <defs>
      <clipPath id="clip0_333_11699">
        <rect width="64" height="62.6245" fill={drawColor} transform="translate(0 -0.0078125)"/>
      </clipPath>
    </defs>
    </svg>
  )
}
